import * as React from 'react';
import { Car16, Walk16 } from '@cian/ui-kit/icons';
import { InlineText2 } from '@cian/ui-kit/typography';
import * as styles from './FromUndergroundTime.css';

interface IFromUndergroundProps {
  timeTransport?: number | null;
  timeWalk?: number | null;
}

export const FromUndergroundTime: React.StatelessComponent<IFromUndergroundProps> = props => {
  const { timeTransport, timeWalk } = props;

  if (timeWalk && timeWalk <= 20) {
    return (
      <>
        <div className={styles['icon']}>
          <Walk16 color={'gray_icons_100'} />
        </div>
        <InlineText2 color={'gray60_100'}>{timeWalk} мин.</InlineText2>
      </>
    );
  }
  if (timeTransport) {
    return (
      <>
        <div className={styles['icon']}>
          <Car16 color={'gray_icons_100'} />
        </div>
        <InlineText2 color={'gray60_100'}>{timeTransport} мин.</InlineText2>
      </>
    );
  }

  return null;
};
